import { DOMAIN_CONTANTS } from '@/core/constants/domains/domain-contants';
import { getDomain } from '@/core/helper/domain.helper';
import { LocalStorageHelper } from '@/core/helper/local-storage-helper';
import { NumericFormat } from 'react-number-format';

type CurrencyConfig = {
    [key: string]: {
        currency: string;
        decimalSeparator: string;
        thousandSeparator: string;
    };
};

const currencyConfig: CurrencyConfig = {
    "tr-TR": {
        currency: "TRY",
        decimalSeparator: ",",
        thousandSeparator: ".",
    },
    "en-US": {
        currency: "USD",
        decimalSeparator: ".",
        thousandSeparator: ",",
    },
};

export const CurrencyInput = ({ value, displayType = 'text' }: any) => {
    const culture = LocalStorageHelper.getCulture();

    const { currency, decimalSeparator, thousandSeparator } = currencyConfig[culture] || currencyConfig["tr-TR"];

    const formatter = new Intl.NumberFormat(culture, {
        style: "currency",
        currency,
    });

    const currencySymbol = formatter.formatToParts(0).find((part) => part.type === 'currency')?.value || '';

    return (
        <NumericFormat
            value={value}
            displayType={displayType}
            decimalScale={2}
            fixedDecimalScale={true}
            allowNegative={false}
            decimalSeparator={decimalSeparator}
            thousandSeparator={thousandSeparator}
            suffix={` ${currencySymbol}`}
        />
    );
};

export const CurrencyFormat = ( value: any) => {
    const culture = LocalStorageHelper.getCulture();

    const currency = getDomain() == DOMAIN_CONTANTS.syncflow ? "USD" : "TRY";
    return new Intl.NumberFormat(culture, {
        style: "currency",
        currency: currency,
    }).format(value);
};

export const CurrencyLabelFormat = ( value: any, currency:string) => {
    const culture = LocalStorageHelper.getCulture();
    return new Intl.NumberFormat(culture, {
        style: "currency",
        currency: currency,
    }).format(value);
};

export const DateFormat = ( value: Date) => {
    const culture = LocalStorageHelper.getCulture();
    return value.toLocaleDateString(culture || "tr-TR")
};

export const DateTimeFormat = ( value: Date) => {
    const culture = LocalStorageHelper.getCulture();
    return value.toLocaleTimeString(culture || "tr-TR")
};

export const DateTimeFormatString = ( value: Date) => {
    const culture = LocalStorageHelper.getCulture();
    return value.toLocaleString(culture || "tr-TR")
};